const { verifyCtid } = require('./vpadn-sdk-check.partial');
const { parseCtidToObj, generateUID } = require("./vpadn-sdk-features.partial");
var SDK_NAME = "j",
  SDK_VERSION = "1.2.0",
  // window.Vpadn global namespace
  VPADN,
  // Debug status (default 0) Vpadn('create', License_Key, {'debug': true});
  DEBUG,
  // Key based on client's id Vpadn('create', License_Key);
  KEY,
  // Encoding (default document.characterSet | charset) Vpadn('create', License_Key, {'encoding': 'UTF-8'})
  // ENCODING,

  // Vpadn unique client ID (cookie use)
  CTID_NAME = "vpadn-ctid",
  // Vpadn unique client ID (url parameter use)
  CTID_URL_PARAM_NAME = "_vpctid",
  // Vpadn session ID (lk-value)
  SEID_NAME = "vpadn-seid",
  // CTID and SEID set in create event
  ISNEW_CTID,
  CTID_LIFE = 730, // 2 years - 2*365 days
  CTID,
  SEID_LIFE = 30 / (24 * 60), // 30 minutes - 30/(24*60) days
  SEID,
  // Cookie Domain
  COOKIE_DOMAIN,
  // Document Referrer
  DOCUMENT_REFERRER = document.referrer,
  // Data Parameter from ADNetwork and DSP
  GAID,
  IDFA,
  CLICK_ID,
  SRC,
  VPID_KEY = "vpadn-vpid",
  JSON_KEY = "vponId",
  JSON_THIRDPARTY_KEY = "ce",
  // the last cookie sync date
  LAST_COOKIE_SYNC = "vpadn-sd",
  //cookie expired in 7 days
  COOKIE_LIFE_DAY = 7,
  THIRD_COOKIE_ENABLED_FLAG = "vpadn-ce";

var secure = window.location.protocol === "https:";

// var ET_HOST = (secure ? 'https' : 'http') + '://tags-dmp.vpadn.com/',
var DMP_HOST = (secure ? "https" : "http") + "://ids-dmp.vpadn.com/",
  protocolName = {
    0: "create",
    // 1: 'mapUser',
    // // others mean event/payload
    // 999: 'others'
  },
  protocol = [];

// different protocol with different url
protocol[protocolName[0]] = DMP_HOST + "set"; // drop client cookie
// protocol[protocolName[1]] = DMP_HOST + 'map'; // cokie sync
// protocol[protocolName[999]] = ET_HOST + 'et'; // event tracking

var urlEncodeComponent = window.encodeURIComponent;
var urlDecodeComponent = window.decodeURIComponent;

var cookie = {
  write: function (name, value, days, domain, path) {
    var date = new Date();
    days = days || 730; // two years
    path = path || "/";
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    var expires = "; expires=" + date.toGMTString();
    var cookieValue = `${name}=${value}${expires}; path=${path}; SameSite=None; Secure`;
    if (domain) {
      cookieValue += "; domain=" + domain;
    }
    document.cookie = cookieValue;
  },
  read: function (name) {
    var allCookie = "" + document.cookie;
    var index = allCookie.indexOf(name);
    if (name === undefined || name === "" || index === -1) return "";
    var ind1 = allCookie.indexOf(";", index);
    if (ind1 == -1) ind1 = allCookie.length;
    return unescape(allCookie.substring(index + name.length + 1, ind1));
  },
  remove: function (name) {
    if (this.read(name)) {
      this.write(name, "", -1, "/");
    }
  },
};

var getUrlParameterByName = function (name, url) {
  // http://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)", "i"),
    results = regex.exec(url);
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
};

var generateSEID = function (key) {
  // <license_key>-<timestamp> 11429772959540-14297738918
  return key + "-" + Math.floor((1 * new Date()) / 100);
};

var testCanWriteCookies = function (domain) {
  // https://github.com/Modernizr/Modernizr/blob/master/feature-detects/cookies.js
  try {
    // Create cookie
    document.cookie = "cookietest=1" + (domain ? "; domain=" + domain : "");
    var ret = document.cookie.indexOf("cookietest=") != -1;
    // Delete cookie
    document.cookie =
      "cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT" +
      (domain ? "; domain=" + domain : "");
    return ret;
  } catch (e) {
    return false;
  }
};

var getTopReachableDomain = function (url) {
  // default as current page url
  if (url === undefined) {
    url = location.href;
  }

  try {
    var hostname;
    if (window.URL) {
      hostname = new URL(url).hostname;
    }

    // double check
    if (hostname === undefined) {
      var parser = document.createElement("a");
      parser.href = url;
      hostname = parser.hostname;
    }

    // detect localhost
    if (hostname === "localhost") {
      return "";
    }

    var domainList = hostname.split("."), // ['www', 'vpon', 'com', 'tw']
      domainListLength = domainList.length,
      domain =
        domainList[domainListLength - 2] +
        "." +
        domainList[domainListLength - 1],
      current = domainListLength - 2;

    while (!testCanWriteCookies(domain) && current >= 0) {
      domain = domainList[--current] + "." + domain;
    }

    if (current < 0) {
      return false;
    }

    return domain;
  } catch (e) {
    return false;
  }
};

var sendBeaconAjax = function (url, cb, errorCb) {
  var xmlHttp = new XMLHttpRequest();

  xmlHttp.timeout = 10000;
  xmlHttp.withCredentials = true;

  xmlHttp.onreadystatechange = function () {
    if (
      xmlHttp.readyState === 4 &&
      xmlHttp.status === 200 &&
      cb !== undefined
    ) {
      cb(xmlHttp.responseText);
    } else if (xmlHttp.readyState === 4 && errorCb !== undefined) {
      errorCb(xmlHttp.responseText);
    }
  };
  xmlHttp.open("GET", url, true); // true for asynchronous
  xmlHttp.send();
};

var SetHelper = {
  setCallback: function (e) {
    var json = JSON.parse(e);

    if (json !== undefined && json[JSON_KEY] !== undefined) {
      // if (json[JSON_KEY] !== '0') {
      //     cookie.write(VPID_KEY, json[JSON_KEY], COOKIE_LIFE_DAY, COOKIE_DOMAIN);
      // }

      //if 3rd cookie setting failed, set a flag in 1st party cookie
      cookie.write(
        THIRD_COOKIE_ENABLED_FLAG,
        json[JSON_THIRDPARTY_KEY],
        COOKIE_LIFE_DAY,
        COOKIE_DOMAIN
      );
    }
  },
  setErrorCallback: function (e) {},
};

var track = function track() {
  var arg = arguments,
    eventType = arg[0];

  if (eventType === "webSDK") {
    create.apply(this, arg);
  }
};

var create = function () {
  var arg = arguments;
  COOKIE_DOMAIN = getTopReachableDomain();
  CTID =
    cookie.read(CTID_NAME) ||
    (window.localStorage && window.localStorage.getItem("vpadn-ctid")) ||
    generateUID();
  if (verifyCtid(CTID)) {
    CTID = `v1_${CTID}.${new Date().getTime()}`;
    window.localStorage && window.localStorage.setItem("vpadn-ctid", CTID);
  }
  cookie.write(CTID_NAME, CTID, CTID_LIFE, COOKIE_DOMAIN); // 1st party domain cookie

  // set SEID (sdk loaded)- !important, we have only one session, therefore we can use the global SEID name
  SEID = cookie.read(SEID_NAME);
  if (
    !SEID || // check not exist
    getTopReachableDomain(DOCUMENT_REFERRER) !== COOKIE_DOMAIN || // check different domain
    !new RegExp("^" + KEY).test(SEID)
  ) {
    // check different license key
    SEID = generateSEID(KEY);
  }
  cookie.write(SEID_NAME, SEID, SEID_LIFE, COOKIE_DOMAIN); // 1st party domain cookie

  //20210105: TOC
  if (
    cookie.read(THIRD_COOKIE_ENABLED_FLAG) !== "0" &&
    cookie.read(THIRD_COOKIE_ENABLED_FLAG) !== "1"
  ) {
    const ctidObj = parseCtidToObj(CTID);
    const { ctid } = ctidObj;
    sendBeaconAjax(
      protocol[protocolName[0]] +
        "?t=" +
        1 * new Date() +
        "&dn=" +
        urlEncodeComponent(COOKIE_DOMAIN) +
        "&ctid=" +
        ctid,
      SetHelper.setCallback,
      SetHelper.setErrorCallback
    );
  }
};

const getCTID = () => {
  return CTID;
};

/**
 * find particular cookie value
 * @param {string} cookieName cookie name
 * @returns cookie value
 */
const getCookie = (key) => {
  if (typeof key !== "string") {
    console.warn("[Vpon-WebSDK] key must be string");
    return;
  }

  const cookies = document.cookie;
  const cookiesArr = cookies.split(";").map((item) => item.trim());
  const targetCookie = cookiesArr.find((cookie) => {
    return cookie.split("=")[0] === key;
  });

  if (!targetCookie) {
    console.warn(`[Vpon-WebSDK] Can't find key => ${key}`);
    return;
  }
  return targetCookie.split("=")[1];
};

module.exports = {
  track,
  generateUID,
  getCTID,
  getCookie,
  getTopReachableDomain
};



// WEBPACK FOOTER //
// ./src/vpadn-sdk-cookie.partial.js